import { render, staticRenderFns } from "./WebLinks.vue?vue&type=template&id=66160690"
import script from "./WebLinks.vue?vue&type=script&lang=js"
export * from "./WebLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports